const actionTypes = {
  setAssignmentsFilter: "seneca/parentUi/setAssignmentsFilter"
};

export default actionTypes;
